var map = {
	"./android-chrome-192x192": 10,
	"./android-chrome-192x192.png": 10,
	"./android-chrome-512x512": 11,
	"./android-chrome-512x512.png": 11,
	"./apple-touch-icon": 12,
	"./apple-touch-icon.png": 12,
	"./favicon-16x16": 13,
	"./favicon-16x16.png": 13,
	"./favicon-32x32": 14,
	"./favicon-32x32.png": 14,
	"./favicon.ico": 61,
	"./mstile-144x144": 15,
	"./mstile-144x144.png": 15,
	"./mstile-150x150": 16,
	"./mstile-150x150.png": 16,
	"./mstile-310x310": 17,
	"./mstile-310x310.png": 17,
	"./mstile-70x70": 18,
	"./mstile-70x70.png": 18,
	"./safari-pinned-tab": 19,
	"./safari-pinned-tab.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;